import { BRAND_SLUGS_WITH_RESTRICTED_RECOMMENDERS, SELLER_IDS_WITH_RESTRICTED_RECOMMENDERS } from "@personalisation/consts";
export var showRecommenderForBrandSlug = function showRecommenderForBrandSlug(brandSlug) {
  return BRAND_SLUGS_WITH_RESTRICTED_RECOMMENDERS.includes(brandSlug);
};
export var showRecommenderForSellerId = function showRecommenderForSellerId(sellerId) {
  return SELLER_IDS_WITH_RESTRICTED_RECOMMENDERS.includes(sellerId);
};